import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { PostCheckoutSurveyOption } from './types';
import { getPostCheckoutSurveyOptions } from '../api';
import { Pencil } from '../assets/Pencil';
import { Spinner } from '../assets/Spinner';
import { Table } from '../component/Table';
import { TableTools } from '../component/TableTools';

const headers = ['Name', 'Source', 'Bucket', 'US Status', 'CA Status'];

export const PostCheckoutSurveyOptions = () => {
  const navigate = useNavigate();
  const [options, setOptions] = useState<PostCheckoutSurveyOption[]>([]);
  const [filteredOptions, setFilteredOptions] = useState<PostCheckoutSurveyOption[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchOptions = async () => {
    setIsLoading(true);
    try {
      const data = await getPostCheckoutSurveyOptions();
      setOptions(data);
      setFilteredOptions(data);
    } catch (e) {
      console.error('Failed to fetch post-checkout survey options', e);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchOptions();
  }, []);

  const searchBy = (text: string, _field: string) => {
    if (!text.trim()) {
      setFilteredOptions(options);
    } else {
      setFilteredOptions(options.filter((o) => o.label.toLowerCase().includes(text.toLowerCase())));
    }
  };

  const mapOption = (option: PostCheckoutSurveyOption) => ({
    Name: option.label,
    Source: option.marketing_source ?? '--',
    Bucket: option.marketing_bucket ?? '--',
    'US Status': option.status_us === 'ACTIVE' ? 'Active' : 'Hidden',
    'CA Status': (
      <div className="flex items-center justify-center gap-2">
        <span>{option.status_ca === 'ACTIVE' ? 'Active' : 'Hidden'}</span>
        <button
          onClick={() =>
            navigate(`/post-checkout-survey-options/${option.id}/edit`, { state: { option } })
          }
        >
          <Pencil className="w-4 h-4 text-gray-500 hover:text-gray-800" />
        </button>
      </div>
    ),
  });

  if (isLoading) return <Spinner />;

  return (
    <div className="relative h-[calc(100vh-77px)] bg-slate50 p-8">
      <div className="flex items-center justify-between mb-3">
        <h1>How did you hear about Spot &amp; Tango?</h1>
      </div>
      <TableTools
        renderPagination={false}
        isLoading={isLoading}
        searchBy={searchBy}
        reFetch={fetchOptions}
        hasData={filteredOptions.length > 0}
        createLabel="Create New Option"
        createLink="/post-checkout-survey-options/create"
      >
        <Table header={headers} data={filteredOptions.map(mapOption)} pageSize={10} />
      </TableTools>
    </div>
  );
};
